<template>
  <div class="favoriteForm">
    <button
      :class="favoriteButtonClass"
      @click="changeFavorite"
    ></button>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
    favoriteAdded: {
      type: Boolean,
      defalut: false,
    },
    favoriteAddedData: {
      type: Boolean,
      defalut: false,
    },
  },
  computed: {
    favoriteButtonClass() {
      return {
        btn: true,
        barFavoriteBtn: true,
        added: this.favoriteAddedData,
      };
    },
  },
  created() {
    this.$emit('change-favorite-added-data', this.favoriteAdded);
  },
  methods: {
    async changeFavorite() {
      let response;
      try {
        response = await axios.post(`course/favorite/${this.id}`);
      } catch (error) {
        console.warn(error);
      }

      const { data } = response;

      if (data.status === 'not login') {
        window.location.href = 'user/login';

        global.Message.show('請先登入會員');

        return false;
      }

      if (data.favoriteAdded) {
        global.Message.show('已經加入喜愛課程');
      } else {
        global.Message.show('已經從喜愛課程中移除');
      }

      this.$emit('change-favorite-added-data', data.favoriteAdded);
    },
  },
};
</script>
